import { useState, useEffect } from "react";
import DoughnutChart from "../../../components/admin/DoughnutChart";
import FilterIcon from "../../../utils/assets/client/filter.svg";
import {
  fetchAllTickets,
  fetchTicketStatus,
  updateTicketStatus,
} from "../../../actions/admin/tickets";
import { Link } from "react-router-dom";
import Badge from "../../../components/admin/Badge";
import StatusSelector from "../../../components/admin/StatusSelector";

const ManageTickets = () => {
  const [ticketsData, setTicketsData] = useState([]);
  const [SearchData, setSearchData] = useState({
    ticketID: "",
    name: "",
    assigned_to: "",
    status: "",
    date: "",
  });
  const [ticketSerach, setTicketSearch] = useState([]);
  const [ticketStatus, setTicketStatus] = useState([]);

  useEffect(() => {
    const token = localStorage.getItem("token");
    fetchAllTickets(token).then((res) => {
      setTicketsData(res.data);
      setTicketSearch(res.data);
    });
    fetchTicketStatus(token).then((res) => {
      setTicketStatus(res.data);
    });
  }, []);

  const handleFilterChange = (values) => {
    // Update filters state
    // Filter data
    const filtered = ticketsData.filter((item) => {
      const ticketsIDMatch =
        !SearchData.ticketID ||
        item.ticket_id.toString().includes(SearchData.ticketID.toString());

      const customer = item?.lead?.customer;
      const customerName = customer
        ? `${customer.first_name} ${customer.last_name}`.toLowerCase()
        : "";
      const nameMatch =
        !SearchData.name ||
        customerName.includes(SearchData.name.toLowerCase().trim());

      const assigned_toMatch =
        !SearchData.assigned_to ||
        item?.assigned_to.toLowerCase() ===
          SearchData.assigned_to.toLowerCase();

      const statusMatch =
        !SearchData.status ||
        item.status.toLowerCase().includes(SearchData.status.toLowerCase());

      const dateMatch =
        !SearchData.date || item.created_at.slice(0, 10) === SearchData.date; // expected format: YYYY-MM-DD

      return (
        ticketsIDMatch &&
        nameMatch &&
        assigned_toMatch &&
        statusMatch &&
        dateMatch
      );
    });
    setTicketSearch(filtered);
    // setIsLoading(true)
    // setTimeout(() => {
    // setFilteredData(filtered);
    // setIsLoading(false)
    // }, 1000)
  };
  const labelData = [
    "Won",
    "Lost",
    "Open",
    "In Progress",
    "Expired",
    "Cancelled",
  ];

  const dataSetValue = [10, 15, 12, 11, 23, 20, 1];

  const handleStatusChange = (data, item) => {
    const token = localStorage.getItem("token")
    const update = {
      ticket_id: item.id,
      status: data.id
    }
    updateTicketStatus(token,update).then((res) => {
      console.log("api...",res);
    })

  };

  function filterStatusData(searchTerm) {
    const filtered = ticketStatus.filter((item) =>
      item.title.toLowerCase().includes(searchTerm.toLowerCase())
    );
    console.log(filtered);

    return filtered[0];
  }

  // const getDeviceName = (brandId) => {
  //   const brand = brands.find((b) => b.id === brandId);
  //   return brand ? brand.name : "Unknown Device";
  // };

  return (
    <div className="bg-light">
      <div className="d-flex justify-content-between align-items-center p-3">
        <h4 className="m-0 ">Manage Tickets</h4>
        <button className="btn  bg-black text-white py-2 px-3 border-0">
          Create Ticket
        </button>
      </div>
      <div className="card_radius  card mb-3 m-3 mt-0">
        <div className="row d-flex justify-content-start align-items-center p-3">
          <div className="col-lg-4 col-md-4 col-sm-12 col-xs-12 mb-3">
            <label className="form-label">Ticket ID</label>
            <input
              type="text"
              className="form-control"
              value={SearchData.estimateId}
              onChange={(e) =>
                setSearchData({ ...SearchData, ticketID: e.target.value })
              }
              placeholder="Enter Ticket ID"
            />
          </div>
          <div className="col-lg-4 col-md-4 col-sm-12 col-xs-12 mb-3">
            <label className="form-label">Customer Name</label>
            <input
              type="text"
              className="form-control"
              value={SearchData.name}
              onChange={(e) =>
                setSearchData({ ...SearchData, name: e.target.value })
              }
              placeholder="Enter customer name"
            />
          </div>
          <div className="col-lg-4 col-md-4 col-sm-12 col-xs-12 mb-3">
            <label className="form-label">Assingned To</label>
            <input
              type="text"
              className="form-control"
              value={SearchData.email}
              onChange={(e) =>
                setSearchData({ ...SearchData, assigned_to: e.target.value })
              }
              placeholder="Enter Employee"
            />
          </div>
          <div className="col-lg-4 col-md-4 col-sm-12 col-xs-12 mb-3">
            <label className="form-label">Ticket Status</label>
            <input
              type="text"
              className="form-control"
              value={SearchData.status}
              onChange={(e) =>
                setSearchData({ ...SearchData, status: e.target.value })
              }
              placeholder="Enter Ticket Status"
            />
          </div>
          <div className="col-lg-4 col-md-4 col-sm-12 col-xs-12 mb-3">
            <label className="form-label">Created Date</label>
            <input
              type="date"
              className="form-control"
              value={SearchData.date}
              onChange={(e) =>
                setSearchData({ ...SearchData, date: e.target.value })
              }
              placeholder="Enter date"
            />
          </div>
        </div>
        <div className="my-1 px-3 pb-3">
          <button
            onClick={() => setTicketSearch(ticketsData)}
            className="btn btn-sm bg-black  text-white p-2 px-3 border-0"
          >
            <img width={20} src={FilterIcon} alt="filter" />{" "}
            <span>Clear Filter</span>
          </button>
          <button
            onClick={handleFilterChange}
            className="btn btn-sm bg-black text-white py-2 px-3 mx-2 border-0"
          >
            Search
          </button>
        </div>
      </div>
      {/* Doughnut Charts start */}
      <div className="row px-3">
        <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12 ">
          <div className="card  border_bg_color card_radius d-flex justify-content-center align-items-center">
            <DoughnutChart labelData={labelData} dataSetValue={dataSetValue} />
          </div>
        </div>
        <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
          <div className="card  border_bg_color card_radius d-flex justify-content-center align-items-center">
            <DoughnutChart labelData={labelData} dataSetValue={dataSetValue} />
          </div>
        </div>
      </div>
      {/* Doughnut Charts end */}
      <div className="my-3 mx-4">
        <div className=" border_bg_col overflow-hidden">
          <p className="txt-head px-3 text-white bg-black mb-0 p-2">
            View Ticket (s)
          </p>
          <table className="table table-hover mb-0">
            <thead>
              <tr className="p-2">
                <td className="px-3">ID</td>
                <td>Devices</td>
                <td>Task</td>
                <td>Customer</td>
                <td>Task Type</td>
                <td>Assigned To</td>
                <td>Due on</td>
                <td>Created Time</td>
                <td>Total</td>
                <td>Status</td>
                <td>More</td>
              </tr>
            </thead>
            <tbody>
              {ticketSerach.length > 0 ? (
                ticketSerach?.map((item) => {
                  return (
                    <tr className="p-3" key={item.id}>
                      <td className="px-3">
                        {" "}
                        <Link
                          className="link_text"
                          to={`/admin/tickets/${item.id}`}
                        >
                          {" "}
                          {item.ticket_id}{" "}
                        </Link>{" "}
                      </td>
                      <td>Task</td>
                      <td>Task</td>
                      <td>
                        {item?.lead.customer?.first_name}{" "}
                        {item?.lead.customer?.last_name}
                      </td>
                      <td>Task Type</td>
                      <td>{item?.assigned_to ? item?.assigned_to : "-"}</td>
                      <td>Due on</td>
                      <td>
                        {item?.created_at
                          ? new Date(item?.created_at).toLocaleDateString(
                              "en-GB",
                              {
                                day: "2-digit",
                                month: "short",
                                year: "numeric",
                              }
                            )
                          : "-"}
                      </td>
                      <td>£ {item.total_price + item.total_tax}</td>
                      <td>
                        {" "}
                        <StatusSelector
                          value={filterStatusData(item.status)}
                          Data={ticketStatus}
                          handleChange={handleStatusChange}
                          item={item}
                        />{" "}
                      </td>
                      <td>More</td>
                    </tr>
                  );
                })
              ) : (
                <tr>
                  <td
                    colspan="11"
                    className="table-active text-center txt-p py-2"
                    style={{ fontWeight: "500" }}
                  >
                    No Records
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default ManageTickets;
